import { useTranslation } from "react-i18next";
import CoolnetPageLayout from "./components/CoolnetPageLayout";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import { coolnetIntegrated } from "@/mocks/coolnet";

export default function IntegratedPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Solución Integrada para Centros de Datos | Coolnet México"
        description="Solución integrada Coolnet para centros de datos: energía, refrigeración, seguridad y monitorización en un sistema inteligente. Distribuidor autorizado en México."
        keywords="solución integrada data center, monitorización centros de datos, gestión energética, seguridad data center, Coolnet integrado, León México"
        canonical="https://ventracore.com.mx/coolnet/solucion-integrada"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "@id": "https://ventracore.com.mx/coolnet/solucion-integrada#product",
            "name": "Solución Integrada para Centros de Datos Coolnet",
            "brand": {
              "@type": "Brand",
              "name": "Coolnet",
            },
            "description": "Solución integrada Coolnet para centros de datos: energía, refrigeración, seguridad y monitorización.",
            "offers": {
              "@type": "AggregateOffer",
              "availability": "https://schema.org/InStock",
              "priceCurrency": "MXN",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Coolnet",
                "item": "https://ventracore.com.mx/coolnet",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Solución Integrada",
                "item": "https://ventracore.com.mx/coolnet/solucion-integrada",
              },
            ],
          },
        ]}
      />
      <CoolnetPageLayout
        title={t("coolnetPage.integrated.title")}
        subtitle={t("coolnetPage.integrated.subtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify mb-10">
            {coolnetIntegrated.intro}
          </p>

          <h3 className="text-xl md:text-2xl font-bold text-magenta mb-8 uppercase tracking-wide">
            {t("coolnetPage.integrated.featuresTitle")}
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {coolnetIntegrated.features.map((feature, index) => (
              <div
                key={index}
                className="bg-white border border-gray-100 rounded-lg p-5 hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-magenta/10 text-magenta mb-4">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={feature.icon} />
                  </span>
                </div>
                <h4 className="text-base font-bold text-text mb-2">
                  {feature.title}
                </h4>
                <p className="text-sm text-text-muted leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-text-muted">
              {coolnetIntegrated.contact}
            </p>
          </div>
        </div>
      </CoolnetPageLayout>
    </Layout>
  );
}
